import { RouteRecordRaw } from "vue-router";
import { PermissionEnum } from "@/app/core/enums/PermissionEnum";

export const routePrivateOffers: Array<RouteRecordRaw> = [
  {
    path: "offers/:uuid?",
    name: "Offers",
    meta: {
      requireAuth: true,
      permissions: [PermissionEnum.LoadsSearch],
    },
    redirect: (to) => {
      return { name: "OffersList", params: { uuid: to.params.uuid } };
    },
    component: () => import("@/app/private/pages/offers/Offers.vue"),
    children: [
      {
        path: "",
        name: "OffersList",
        component: () => import("@/app/private/pages/offers/OffersList.vue"),
      },
    ],
  },
];
